import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';

import { ButtonComponent } from '../button/button.component';
import { ModalHeaderCloseButtonComponent } from '../modal/components/modal-header/modal-header-close-button.component';
import { ModalHeaderComponent } from '../modal/components/modal-header/modal-header.component';
import { ModalHeaderTitleComponent } from '../modal/components/modal-header/modal-header-title.component';
import { ModalHeaderButtonsComponent } from '../modal/components/modal-header/modal-header-buttons.component';
import { ModalCloseDirective } from '../modal/components/modal-close/modal-close-button.directive';

import type { Observable } from 'rxjs';
import type { AboutData, ActuatorInfo } from './about-dialog.service';

/**
 * About Dialog Component
 *
 * Content component for modal displaying about information such as application and browser versions.
 *
 */
@Component({
  imports: [
    ButtonComponent,
    ModalHeaderComponent,
    ModalHeaderTitleComponent,
    ModalHeaderButtonsComponent,
    ModalHeaderCloseButtonComponent,
    AsyncPipe,
    TranslateDirective,
    ModalCloseDirective
  ],
  selector: 'td-wb-about-dialog',
  templateUrl: 'about-dialog.component.html',
  styleUrls: ['about-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutDialogComponent {
  aboutData: InputSignal<AboutData> = input.required<AboutData>();
  actuatorData: InputSignal<Observable<ActuatorInfo> | null> = input<Observable<ActuatorInfo> | null>(null);
}
